import { Controller } from "stimulus"
import JQuery from 'jquery'

export default class extends Controller {
  connect() {
    JQuery(this.element.querySelector('[data-toggle="popover"]')).popover()
  }
}
